const BLOOMREACH_ACTIONS = Object.freeze({
  ACCEPT: 'accept',
  REJECT: 'reject',
  ADD: 'add',
  REMOVE: 'remove',
});

const BLOOMREACH_CATEGORIES = Object.freeze({
  NEWSLETTER: 'Newsletter',
  RETARGETING_PAID_ADS: 'Retargeting (Paid Ads)',
  REMARKETING_EMAIL: 'Remarketing (Email)',
  PRODUCT_NEWS: 'Product News',
});

const BLOOMREACH_CATEGORIES_EROW = Object.freeze({
  NEWSLETTER: BLOOMREACH_CATEGORIES.NEWSLETTER,
  RETARGETING_PAID_ADS: BLOOMREACH_CATEGORIES.RETARGETING_PAID_ADS,
  REMARKETING_EMAIL: BLOOMREACH_CATEGORIES.REMARKETING_EMAIL,
  PRODUCT_NEWS: BLOOMREACH_CATEGORIES.PRODUCT_NEWS,
});

const BLOOMREACH_CATEGORIES_AMERICAS = Object.freeze({
  NEWSLETTER: BLOOMREACH_CATEGORIES.NEWSLETTER,
  REMARKETING_EMAIL: BLOOMREACH_CATEGORIES.REMARKETING_EMAIL,
});

const BLOOMREACH_MESSAGES = Object.freeze({
  OPT_IN: 'Web form opt-in',
  OPT_OUT: 'Web form opt-out',
});

const BLOOMREACH_EVENT = Object.freeze({
  CART_UPDATE: 'cart_update',
  CHECKOUT: 'checkout',
});

export {
  BLOOMREACH_ACTIONS,
  BLOOMREACH_CATEGORIES,
  BLOOMREACH_CATEGORIES_EROW,
  BLOOMREACH_CATEGORIES_AMERICAS,
  BLOOMREACH_MESSAGES,
  BLOOMREACH_EVENT,
};
